import { render, staticRenderFns } from "./StepVerify.vue?vue&type=template&id=1f6e2c66&scoped=true"
import script from "./StepVerify.vue?vue&type=script&lang=js"
export * from "./StepVerify.vue?vue&type=script&lang=js"
import style0 from "./StepVerify.vue?vue&type=style&index=0&id=1f6e2c66&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f6e2c66",
  null
  
)

export default component.exports